export const USERSREDUCER = (state = { all_users: {}, search: { text: '', results: [] }, add_user: { addingUserStatus: false }, update_user: { isEdit: false, update_user_key: null, new_user_role: '', curr_list_page: 1 } }, action) => {
  switch (action.type) {
    case 'SET_ALL_USERS':
      return {
        ...state,
        all_users: action.data
      }
    case 'CHANGE_USER_DATA':
      return {
        ...state,
        update_user: {
          isEdit: true,
          update_user_key: action.data
        }
      }  
    case 'RESET_EDIT_USER_DATA':
      return{
        ...state,
        update_user: {
          isEdit: false,
          update_user_key: null,
          new_user_role: ''
        }
      }
    case 'RESET_SEARCH_DATA':
      return{
        ...state,
        search: {
          text: '',
          results: []
        }
      }
    case 'SET_ADDING_USER_STATUS':
      state.add_user.addingUserStatus = action.data;  
      return{
        ...state
      }
    case 'UPDATE_NEW_USER_ROLE':
      state.update_user.new_user_role = action.data;
      return{
        ...state
      }
    case 'SET_CURRENT_LIST_PAGE':
      state.update_user.curr_list_page = action.data;
      return{
        ...state
      }
    case 'SET_SEARCH_TEXT':
      state.search.text = action.data;
      return{
        ...state
      }
    case 'SET_SEARCH_RESULTS':
      state.search.results = action.data;
      return{
        ...state
      }
    case 'RESET_USER_REDUCER':
      return state;
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/Users/UsersReducer.js